import { JoonUIColor, SPACING } from "@joonapp/web-shared"
import { Tooltip as ReactTooltip } from "react-tooltip"

const Tooltip = ({
  children,
  id,
}: {
  children: JSX.Element | JSX.Element[]
  id: string
}) => {
  return (
    <ReactTooltip
      style={{
        padding: SPACING.space2,
        background: JoonUIColor.background.inverted,
        borderRadius: SPACING.space2,
        color: JoonUIColor.text.inverted,
        zIndex: 500,
      }}
      id={id}
      arrowColor="transparent"
    >
      {children}
    </ReactTooltip>
  )
}

export default Tooltip
